import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
import { ROLES } from '../utils/constants'
import { checkAccessRights } from '../utils/functions/accessRight'

const USER = process.env.REACT_APP_API_URL
const ADMIN = process.env.REACT_APP_API_URL_admin

const baseQuery = fetchBaseQuery({
  // baseUrl: `${process.env.REACT_APP_API_URL_admin}/matchstatement`,
 baseUrl: `${checkAccessRights(ROLES.ADMIN_ROLE) || checkAccessRights(ROLES.SUPER_ADMIN_ROLE) ? ADMIN : USER}`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');
    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const eDocumentsApi = createApi({
  reducerPath: 'eDocumentsApi',
  baseQuery,
  endpoints: (builder) => ({
    getAttachment: builder.mutation({
      query: (query) => {
        const { so_number, accesstoken } = query;
        return {
          url: '/sale-order/download-Attachment',
          method: 'POST',
          body: {
            so_number,
            accesstoken,
          }
        };
      },
      transformResponse: (response, _, arg) => {
        return { ...response, query: arg };
      },
    }),
    getCreditNote: builder.mutation({
      query: (query) => {
        const { get_cn, accesstoken, sorgcode, invoice_no } = query;
        return {
          url: '/sale-order/download-CN08',
          method: 'POST',
          body: {
            get_cn,
            accesstoken,
            sorgcode,
            invoice_no
          }
        };
      },
      transformResponse: (response, _, arg) => {
        return { ...response, query: arg };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAttachmentMutation, useGetCreditNoteMutation } = eDocumentsApi;
